(() => {
  const BODY_BG_CLASS = 'product-header--bg';
  const BODY_HIDDEN_CLASS = 'product-header--hidden';
  const BREAKPOINT = 1024;

  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.wt-header');
    if (!header) return;

    if (window.innerWidth < BREAKPOINT) {
      initMobile();
    } else {
      initDesktop();
    }
  });

  // Desktop: transparent header → white bg on scroll, back to transparent at top
  function initDesktop() {
    let prevScrollY = window.pageYOffset;
    let ticking = false;

    const onFrame = () => {
      ticking = false;
      const y = window.pageYOffset;
      if (y <= 2) {
        document.body.classList.remove(BODY_BG_CLASS);
      } else {
        document.body.classList.add(BODY_BG_CLASS);
      }
      prevScrollY = y;
    };

    window.addEventListener('scroll', () => {
      prevScrollY = window.pageYOffset;
      if (!ticking) {
        requestAnimationFrame(onFrame);
        ticking = true;
      }
    }, { passive: true });
  }

  // Mobile: header always white, hides on gallery scroll down, shows on scroll up
  function initMobile() {
    const gallery = document.querySelector('.brn-product__gallery');
    if (!gallery) return;

    let prevScrollTop = gallery.scrollTop;
    let ticking = false;

    const onFrame = () => {
      ticking = false;
      const y = gallery.scrollTop;
      const delta = y - prevScrollTop;

      if (delta < 0 || y <= 0) {
        document.body.classList.remove(BODY_HIDDEN_CLASS);
      } else if (delta > 0) {
        document.body.classList.add(BODY_HIDDEN_CLASS);
      }

      prevScrollTop = y;
    };

    gallery.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(onFrame);
        ticking = true;
      }
    }, { passive: true });
  }
})();
